import React from "react";
import { NavLink } from "react-router-dom";

import './header.css'
const Header = () => {
 
  
  return (  
  <header className="header">
  <nav className="nav">
      <a href="/" className="holder-logo">
        Resume
      </a> 
        <div className="header-links full-height">
       
          <ul id="nav-mid">
            <li>
            <NavLink className="btn-nvt-gm" to="/resume-templates">
            Resume Templates
            </NavLink>
            </li> 
            <li className="holder-pricing">            
              <NavLink className="btn-nvt-gm" to="/about-us">
              About Us
              </NavLink>
            </li>        
          </ul>
            
      </div>   
    </nav>
  </header>

  );
};

 
export default (Header);